import React, { useEffect, useState } from "react";
import CustomAddActionCard from "../../../common/components/CustomAddActionCard/CustomAddActionCard";
import CardContentActionTile from "../../../common/components/CardContentActionTile/CardContentActionTile";
import { Box } from "@mui/system";
import CustomEditCard from "../../../common/components/CustomEditCard/CustomEditCard";
import ReviewTile from "../../../common/components/ReviewTile/ReviewTile";
import TeamReviewTile from "../../../common/components/TeamReviewTile/TeamReviewTile";
import TeamReviewModalController from "../../../common/Modals/PerofomanceModals/TeamReviewModal/TeamReviewModalController";

interface propsType {
  trans?: any;
}
const TeamReviewsPresenter: React.FC<propsType> = ({ trans }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div>
      <CustomEditCard
        card_title={trans("Team Reviews")}
        card_height="310px"
        showEditButton={false}
      >
        <Box style={{ marginBottom: "24px" }} />

        <Box onClick={() => setOpenModal(true)} style={{ cursor: "pointer" }}>
          <TeamReviewTile
            review_heading="Perfomance - Check in"
            review_value="85"
            name="Khanzada hanzla"
            days="5"
          />
        </Box>
        {openModal && (
          <TeamReviewModalController
            closeModal={() => setOpenModal(false)}
            isModalOpen={openModal}
            trans={trans}
          />
        )}
      </CustomEditCard>

      {/* Add Employee Skill Modal */}
    </div>
  );
};

export default TeamReviewsPresenter;
